export function TailwindIndicator() {
  if (import.meta.env.PROD) return null;

  return (
    <div className="fixed bottom-1 left-1 z-[9999] flex h-8 w-8 items-center justify-center rounded-full bg-red-600 p-3 font-mono text-xs font-bold text-white shadow-lg">
      <div className="block sm:hidden">xs</div>
      <div className="hidden sm:block md:hidden">sm</div>
      <div className="hidden md:block lg:hidden">md</div>
      <div className="hidden lg:block xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  );
}
